import styled from 'styled-components'
import { theme } from '../../styles/theme';

export const Tab = styled.button`
  all: unset;
  box-sizing: border-box;
  flex: 1 1 0;
  min-width: 0;
  max-width: 300px;

  gap: 6px;
  display: flex;
  align-items: center;
  flex-direction: column;

  padding-bottom: 20px;
  margin-bottom: -1px;

  cursor: pointer;
  border-bottom: 3px solid ${props => props.active ? theme.colors.green.Verde_AgroReceita : 'transparent'};
  transition: border-color .15s;

  b {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    gap: 8px;
    font-size: 12px;
    font-weight: ${props => props.active ? 800 : 700};
    letter-spacing: 0.3px;
    text-transform: uppercase;
    text-align: center;
    white-space: nowrap;
    color: ${props => props.active ? theme.colors.gray.Cinza_2 : theme.colors.gray.Cinza_7};
  }

  span {
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: ${theme.colors.gray.Cinza_7};
  }

  @media only screen and (max-width: 480px) {
    b {
      flex-direction: column;
      gap: 4px;
      font-size: 10.5px;
      line-height: 1.2;
      white-space: normal;
    }

    span {
      display: none;
    }
  }
`;
